// extracted by mini-css-extract-plugin
export var centerText = "_cy-8";
export var container = "_cy-0";
export var doughnutContainer = "_cy-7";
export var legend = "_cy-a";
export var legendItemColorDisplay = "_cy-b";
export var legendItemLabel = "_cy-d";
export var legendItemValue = "_cy-c";
export var lg = "_cy-5";
export var maxWidth = "_cy-9";
export var md = "_cy-4";
export var responsive = "_cy-6";
export var sm = "_cy-3";
export var xs = "_cy-2";
export var xxs = "_cy-1";